import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';

export const Badge = memo(({ backgroundColor, color, size = 12, content }) => {
  const { styles, colors } = useStyle();
  if (!backgroundColor) backgroundColor = colors.blue8;
  if (!color) color = colors.blue1;
  return (
    <View style={[styles.badgeContainer, { backgroundColor }]}>
      <Text style={{ fontSize: size, color }}>{content}</Text>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  badgeContainer: {
    borderRadius: 50,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
}));
